import { ASAMA_PERFORMANS_RAPOR_SUREC_LISTESI_GETIR } from "../constants/requestUrls";
import { getRequest } from "../request";

const asamaPerformansRaporSurecListesi = (parentObjectId) => {
    return getRequest({ url: ASAMA_PERFORMANS_RAPOR_SUREC_LISTESI_GETIR  });
}

export default asamaPerformansRaporSurecListesi;